<template>
  <router-view />
  <AdminSystemDialog />
</template>

<script setup>
import AdminSystemDialog from '@/components/AdminSystemDialog.vue'
import { installAdminDialogWindowShims } from '@/utils/adminDialog'

installAdminDialogWindowShims()
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
}

table tbody tr:hover {
  background: #eef4ff;
}
table tbody tr:hover td {
  background: transparent;
}
</style>
